import util from '@bmp-vue/core/api/util'

const controller = 'Usuario'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetGroups: function (dto) {
    return util.Axios.GetAll(controller + '/GetGroups', dto)
  },
  UserGroups: function (dto) {
    return util.Axios.GetAll(controller + '/GetUserGroups', dto)
  },
  GetUsuariosPortal: function (codigoPortal) {
    return util.Axios.Get(controller + '/GetUsuariosPortal', codigoPortal)
  },
  AlteraIndicadorBloqueio: function (dto) {
    return util.Axios.Put(controller + '/AlteraIndicadorBloqueio', dto.codigo, dto)
  },
  PutUserGroup: function (dto, tipoRequest) {
    dto.tipoRequest = tipoRequest
    return util.Axios.Put(controller + '/PutUserGroup', dto.codigo, dto)
  },
  DownloadArquivoModeloImportacao: function () {
    return util.Axios.GetBlob(`${controller}/DownloadArquivoModeloImportacao`, {})
  },
  DesbloquearUsuarioSSO: function (email) {
    const params = { email: email }
    return util.Axios.GetParams(controller + '/DesbloquearUsuarioSSO', params)
  },
})
